export enum RequestDiagramColors {
    Normal = '#92D4F9',
    Late = '#CAD0CE',
    Unplanned = '#EA8223',
}
